import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import {
  cloneDeep,
  map,
  uniq,
  union,
  filter,
  forEach,
  difference,
  values,
  orderBy,
} from "lodash";

@Component({
  selector: "multiselect-with-helpers",
  templateUrl: "./multiselect-with-helpers.component.html",
  styleUrls: ["./multiselect-with-helpers.component.scss"],
})
export class MultiselectWithHelpersComponent implements OnInit, OnChanges {
  @Input() items;
  @Input() groupBy;
  @Input() bindLabel;
  @Input() placeholder;
  @Input() selectedItems;

  @Output() itemsSelected = new EventEmitter();

  selectedAll = false;
  helperCategories = [];
  selectedHelperCategories = {};

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change) {
    this.helperCategories = uniq(map(this.items, this.groupBy));
    this.items = this.orderItems(this.items);
    if (this.selectedItems && this.selectedItems.length > 0) {
      this.checkSelectedCategories();
    }
  }

  orderItems(items) {
    if (this.helperCategories && this.helperCategories.length > 0) {
      // first, order the items by their helper category, then alphabetically in each category
      return orderBy(
        items,
        [
          (item) => this.helperCategories.indexOf(item[this.groupBy]),
          (item) =>
            item[this.bindLabel]
              ? item[this.bindLabel].toLowerCase()
              : item[this.bindLabel],
        ],
        ["asc", "asc"]
      );
    } else {
      return orderBy(
        items,
        (item) =>
          item[this.bindLabel]
            ? item[this.bindLabel].toLowerCase()
            : item[this.bindLabel],
        ["asc"]
      );
    }
  }

  selectAllClicked() {
    if (this.selectedAll) {
      // select all has been checked, make selectedItems = all items
      this.selectedItems = cloneDeep(this.items);
      // select all the helper categories
      forEach(this.helperCategories, (category) => {
        this.selectedHelperCategories[category] = true;
      });
    } else {
      // select all has been unchecked, clear all selectedItems
      this.selectedItems = null;
      // clear all the selected helper categories
      forEach(this.helperCategories, (category) => {
        this.selectedHelperCategories[category] = false;
      });
    }
    this.itemsSelected.emit(this.selectedItems);
  }

  selectHelperCategoryClicked(category) {
    if (this.selectedHelperCategories[category]) {
      // this helper category has been selected, make selectedItems = all items that were previously selected + all items in this category
      this.selectedItems = union(
        this.selectedItems,
        filter(this.items, [this.groupBy, category])
      );
    } else {
      // this helper category has been unselected, remove all items from that category from selectedItems
      this.selectedItems = filter(this.selectedItems, (item) => {
        return item[this.groupBy] != category;
      });
    }
    // if all the helper categories are "true", then "Select All" is true
    // otherwise, "Select All" is false
    this.selectedAll =
      values(this.selectedHelperCategories).length ==
        this.helperCategories.length &&
      uniq(values(this.selectedHelperCategories)).length == 1 &&
      uniq(values(this.selectedHelperCategories))[0] == true;
    this.itemsSelected.emit(this.selectedItems);
  }

  itemSelected() {
    // we've manually checked or unchecked an item
    this.checkSelectedCategories();
    this.itemsSelected.emit(this.selectedItems);
  }

  checkSelectedCategories() {
    // we want to see if we've checked all the items in a helper category, so we can check the helper category's box
    forEach(this.helperCategories, (category) => {
      difference(
        filter(this.items, [this.groupBy, category]),
        filter(this.selectedItems, [this.groupBy, category])
      ).length === 0
        ? (this.selectedHelperCategories[category] = true)
        : (this.selectedHelperCategories[category] = false);
    });
    // we want to see if we've selected all items
    this.selectedAll = this.checkSelectedAll(this.items, this.selectedItems);
  }

  checkSelectedAll(items, selectedItems) {
    return items.every((ai) => selectedItems.includes(ai));
  }
}
